(() => {
  if (window.EtoileMonogramPairingAdapter) return;
  window.EtoileMonogramPairingAdapter = true;

  const editorParams = new URLSearchParams(window.location.search);
  let variantProofIssue = '';
  const activeProductVariantId = (targetId, targetColor) => {
    const formId = document.querySelector('form[action*="/cart/add"] [name="id"]')?.value || '';
    const targetImage = editorParams.get('etoile_target_image');
    // Some themes leave a hidden add-to-cart form on the default variant even
    // after the visible swatch and gallery have changed. Never use that form
    // alone when Studio supplies the expected variant photo.
    if (!targetImage) {
      variantProofIssue = 'Studio did not send the expected photo';
      return formId;
    }
    const normalize = (value) => (value || '').toLowerCase().replace(/[^a-z0-9]/g, '');
    const colorLabels = Array.from(document.querySelectorAll('label, legend, span, p, div'))
      .filter((element) => element.getClientRects().length)
      .map((element) => ({
        text: (element.innerText || element.textContent || '').replace(/\s+/g, ' ').trim(),
        top: element.getBoundingClientRect().top
      }))
      .filter(({text}) => /^colou?r\s*:\s*\S/i.test(text) && text.length < 80)
      // The product color is above the monogram controls. Choosing the
      // shortest label can accidentally pick a monogram foil color instead.
      .sort((left, right) => left.top - right.top || left.text.length - right.text.length);
    const selectedColor = colorLabels[0]?.text.replace(/^colou?r\s*:\s*/i, '') ||
      (document.body?.innerText || '').match(/(?:^|\n)\s*colou?r\s*:\s*([^\n]+)/i)?.[1]?.trim();
    if (normalize(selectedColor) !== normalize(targetColor)) {
      variantProofIssue = 'visible color label not confirmed; read ' + (selectedColor || 'none');
      return '';
    }
    const visibleImages = Array.from(document.querySelectorAll('img'))
      .filter((image) => {
        const rect = image.getBoundingClientRect();
        return image.getClientRects().length &&
        rect.width >= 150 && rect.height >= 150 &&
        rect.left < window.innerWidth && rect.right > 0 &&
        rect.top < window.innerHeight && rect.bottom > 0;
      });
    const imageName = (url) => {
      try {
        return decodeURIComponent(new URL(url, window.location.href).pathname.split('/').pop() || '')
          .toLowerCase()
          .replace(/_\d+x\d*(?=\.(?:png|jpe?g|webp)$)/, '');
      } catch (_) {
        return '';
      }
    };
    if (!visibleImages.some((image) => imageName(image.currentSrc || image.src) === imageName(targetImage))) {
      variantProofIssue = 'visible product photo not matched';
      return '';
    }
    variantProofIssue = '';
    return targetId;
  };
  let variantRetryStarted = false;
  const matchesRequestedVariant = (targetId, targetColor) => {
    if (!targetId) return false;
    if (activeProductVariantId(targetId, targetColor) === targetId) return true;
    // Shopify can redirect from the shop domain to the storefront and lose
    // its variant query. Retry once on the final host, never silently edit
    // the first/default color if Shopify still refuses the selection.
    if (!variantRetryStarted && editorParams.get('variant') !== targetId &&
        editorParams.get('etoile_variant_retry') !== '1') {
      variantRetryStarted = true;
      const retryUrl = new URL(window.location.href);
      retryUrl.searchParams.set('variant', targetId);
      retryUrl.searchParams.set('etoile_variant_retry', '1');
      window.location.replace(retryUrl.toString());
    }
    return false;
  };
  // The group-review link is read-only: show initials for inspection without
  // enabling the editor's drag or save behavior on the Shopify draft.
  if (editorParams.get('etoile_review_preview') === '1' &&
      editorParams.get('etoile_placement_editor') !== '1') {
    const targetId = editorParams.get('etoile_target_variant') || '';
    const targetColor = editorParams.get('etoile_target_color') || 'the selected color';
    const reviewBar = document.createElement('div');
    reviewBar.setAttribute('data-etoile-placement-review-preview', '');
    Object.assign(reviewBar.style, {
      position: 'fixed',
      left: '50%',
      bottom: '104px',
      transform: 'translateX(-50%)',
      zIndex: '2147483647',
      padding: '12px 16px',
      background: '#ffffff',
      border: '1px solid #1f3448',
      boxShadow: '0 12px 36px rgba(0,0,0,.2)',
      fontFamily: 'Arial, sans-serif',
      fontSize: '13px',
      color: '#1f3448'
    });
    reviewBar.textContent = 'Opening RNR for draft review…';
    document.addEventListener('DOMContentLoaded', () => document.body.appendChild(reviewBar), {once: true});
    if (document.body) document.body.appendChild(reviewBar);
    let attempts = 0;
    let openedSection = false;
    const showReview = () => {
      if (!matchesRequestedVariant(targetId, targetColor)) {
        reviewBar.textContent = 'Studio cannot confirm ' + targetColor + ' (' + variantProofIssue +
          '). RNR can be inspected, but do not confirm this color yet.';
        return;
      }
      const letters = document.querySelector('.product-monogram input.input-letter');
      if ((!letters || !letters.getClientRects().length) && !openedSection) {
        const toggle = Array.from(document.querySelectorAll('button, summary, [role="button"], div, span, h2, h3'))
          .filter(element =>
          !element.closest('[data-etoile-placement-review-preview]') &&
          element.getClientRects().length &&
          /^\+?\s*monogramming\s*$/i.test((element.textContent || '').trim()) &&
          element.getAttribute('aria-expanded') !== 'true'
          )
          .sort((left, right) => (left.textContent || '').length - (right.textContent || '').length)[0];
        if (toggle) {
          openedSection = true;
          toggle.click();
        }
      }
      if (letters && (letters.maxLength <= 0 || letters.maxLength >= 3) && !letters.value) {
        letters.value = 'RNR';
        letters.dispatchEvent(new Event('input', {bubbles: true}));
      }
      const preview = document.querySelector('.monogram-preview');
      if (letters && letters.value === 'RNR' && (!preview || !preview.getClientRects().length)) {
        letters.dispatchEvent(new Event('input', {bubbles: true}));
      }
      if (letters && letters.value === 'RNR' && preview && preview.getClientRects().length) {
        reviewBar.textContent = 'Review RNR on this Shopify draft. Return to Studio to confirm this color.';
        window.clearInterval(reviewInterval);
      } else if (++attempts >= 20) {
        reviewBar.textContent = 'Open + Monogramming and enter RNR to check this color on the draft.';
        window.clearInterval(reviewInterval);
      }
    };
    const reviewInterval = window.setInterval(showReview, 500);
    window.setTimeout(showReview, 0);
  }
  if (editorParams.get('etoile_placement_editor') === '1') {
    const editorNonce = editorParams.get('etoile_editor_nonce') || '';
    const targetId = editorParams.get('etoile_target_variant') || '';
    const targetColor = editorParams.get('etoile_target_color') || 'the selected color';
    const editorBar = document.createElement('div');
    editorBar.setAttribute('data-etoile-placement-editor', '');
    Object.assign(editorBar.style, {
      position: 'fixed',
      left: '50%',
      bottom: '104px',
      transform: 'translateX(-50%)',
      zIndex: '2147483647',
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      padding: '12px 16px',
      background: '#ffffff',
      border: '1px solid #1f3448',
      boxShadow: '0 12px 36px rgba(0,0,0,.2)',
      fontFamily: 'Arial, sans-serif',
      fontSize: '13px',
      color: '#1f3448'
    });
    const editorStatus = document.createElement('span');
    editorStatus.textContent = 'Opening monogramming preview…';
    const saveButton = document.createElement('button');
    saveButton.type = 'button';
    saveButton.textContent = 'Save placement';
    saveButton.disabled = true;
    Object.assign(saveButton.style, {
      border: '0',
      padding: '10px 16px',
      background: '#1f3448',
      color: '#ffffff',
      cursor: 'pointer',
      textTransform: 'uppercase',
      letterSpacing: '.08em',
      fontSize: '11px'
    });
    editorBar.append(editorStatus, saveButton);
    document.addEventListener('DOMContentLoaded', () => document.body.appendChild(editorBar), {once: true});
    if (document.body) document.body.appendChild(editorBar);

    let editablePreview = null;
    let dragState = null;
    let saveTimeout = null;
    let saveInProgress = false;
    let saveFeedbackShown = false;
    let saveCompleted = false;
    let lastSavedPosition = null;
    let pendingSavePosition = null;
    const readyMessage = () => lastSavedPosition
      ? 'Placement changed. Save placement to update this color.'
      : 'Drag RNR into place, then save placement.';
    const makeEditable = () => {
      const preview = document.querySelector('.monogram-preview');
      if (!preview || preview === editablePreview) return;
      editablePreview = preview;
      preview.style.cursor = 'move';
      preview.style.outline = '2px dashed #1f3448';
      preview.style.outlineOffset = '4px';
      preview.style.touchAction = 'none';
      preview.addEventListener('pointerdown', (event) => {
        if (saveInProgress) return;
        const frame = preview.parentElement && preview.parentElement.getBoundingClientRect();
        if (!frame) return;
        event.preventDefault();
        preview.setPointerCapture(event.pointerId);
        dragState = {
          pointerId: event.pointerId,
          startX: event.clientX,
          startY: event.clientY,
          frameWidth: frame.width,
          frameHeight: frame.height,
          left: parseFloat(preview.style.left) || 0,
          top: parseFloat(preview.style.top) || 0
        };
      });
      preview.addEventListener('pointermove', (event) => {
        if (saveInProgress || !dragState || dragState.pointerId !== event.pointerId) return;
        const left = dragState.left + ((event.clientX - dragState.startX) / dragState.frameWidth) * 100;
        const top = dragState.top + ((event.clientY - dragState.startY) / dragState.frameHeight) * 100;
        preview.style.left = left + '%';
        preview.style.top = top + '%';
        preview.style.marginLeft = '0';
        preview.style.marginTop = '0';
        if (lastSavedPosition) {
          const unchanged = Math.abs(left - lastSavedPosition.left) < 0.00001 &&
            Math.abs(top - lastSavedPosition.top) < 0.00001;
          saveCompleted = unchanged;
          saveFeedbackShown = unchanged;
          saveButton.disabled = unchanged || activeProductVariantId(targetId, targetColor) !== targetId;
          editorStatus.textContent = unchanged
            ? 'Saved to this color. You can close this page.'
            : readyMessage();
        }
      });
      const stopDrag = (event) => {
        if (dragState && dragState.pointerId === event.pointerId) dragState = null;
      };
      preview.addEventListener('pointerup', stopDrag);
      preview.addEventListener('pointercancel', stopDrag);
    };
    new MutationObserver(makeEditable).observe(document.documentElement, {childList: true, subtree: true});
    window.setInterval(makeEditable, 500);
    makeEditable();

    // Only open and prefill the Studio editor, never the customer storefront.
    // The theme can render the initials field before its accordion is open,
    // so finding the field does not mean the draggable preview is visible.
    if (editorNonce) {
      let openedSection = false;
      let previewReady = false;
      let attempts = 0;
      const prepareEditor = () => {
        // The preview poller must not undo a save request, a server error, or
        // the final confirmation from Studio.
        if (saveInProgress || saveFeedbackShown) return;
        const verified = matchesRequestedVariant(targetId, targetColor);
        if (!verified) {
          saveButton.disabled = true;
          editorStatus.textContent = 'Studio cannot confirm ' + targetColor + ' (' + variantProofIssue +
            '). RNR is for inspection; saving is disabled. Nothing was saved.';
        } else if (previewReady) {
          saveButton.disabled = false;
          editorStatus.textContent = readyMessage();
        }
        if (previewReady) return;
        const letters = document.querySelector('.product-monogram input.input-letter');
        if ((!letters || !letters.getClientRects().length) && !openedSection) {
          const toggle = Array.from(document.querySelectorAll('button, summary, [role="button"], div, span, h2, h3'))
            .filter(element =>
            !element.closest('[data-etoile-placement-editor]') &&
            element.getClientRects().length &&
            /^\+?\s*monogramming\s*$/i.test((element.textContent || '').trim()) &&
            element.getAttribute('aria-expanded') !== 'true'
            )
            .sort((left, right) => (left.textContent || '').length - (right.textContent || '').length)[0];
          if (toggle) {
            openedSection = true;
            toggle.click();
          }
        }
        if (letters && (letters.maxLength <= 0 || letters.maxLength >= 3) && !letters.value) {
          letters.value = 'RNR';
        }
        const preview = document.querySelector('.monogram-preview');
        if (letters && letters.value === 'RNR' && (!preview || !preview.getClientRects().length) && attempts < 20) {
          letters.dispatchEvent(new Event('input', {bubbles: true}));
        }
        makeEditable();
        if (editablePreview && editablePreview.getClientRects().length && letters && letters.value === 'RNR') {
          previewReady = true;
          saveButton.disabled = !verified;
          if (verified) editorStatus.textContent = readyMessage();
        } else if (++attempts >= 20) {
          editorStatus.textContent = 'Open + Monogramming to show RNR, then drag it into place.';
        }
      };
      window.setTimeout(prepareEditor, 0);
      window.setInterval(prepareEditor, 500);
    } else {
      editorStatus.textContent = 'Open this editor from Etoile Studio to enter initials.';
    }

    saveButton.addEventListener('click', () => {
      if (saveInProgress || saveCompleted) return;
      const activeVariantId = activeProductVariantId(targetId, targetColor);
      if (!targetId || !matchesRequestedVariant(targetId, targetColor)) {
        editorStatus.textContent = 'Studio cannot confirm ' + targetColor + ' (' + variantProofIssue + '). Nothing was saved.';
        saveButton.disabled = true;
        return;
      }
      makeEditable();
      if (!editablePreview || !window.opener) {
        editorStatus.textContent = 'Open this editor from Etoile Studio, then enter initials.';
        return;
      }
      const horizontal = (parseFloat(editablePreview.style.left) || 0) - 4;
      const vertical = (parseFloat(editablePreview.style.top) || 0) - 3;
      pendingSavePosition = {left: horizontal + 4, top: vertical + 3};
      dragState = null;
      saveFeedbackShown = false;
      saveInProgress = true;
      saveButton.disabled = true;
      editorStatus.textContent = 'Contacting Etoile Studio…';
      saveTimeout = window.setTimeout(() => {
        if (!saveInProgress) return;
        editorStatus.textContent = 'No reply from Studio. Check the Studio tab before reopening this editor; do not assume this saved.';
      }, 12000);
      window.opener.postMessage({
        type: 'etoile:placement-save',
        nonce: editorNonce,
        variantId: targetId,
        activeVariantId,
        horizontal,
        vertical
      }, '*');
    });

    window.addEventListener('message', (event) => {
      const message = event.data;
      if (!message || message.type !== 'etoile:placement-saved' || message.nonce !== editorNonce ||
          event.source !== window.opener || !saveInProgress || saveCompleted) return;
      window.clearTimeout(saveTimeout);
      if (message.stage) {
        editorStatus.textContent = message.stage;
        saveTimeout = window.setTimeout(() => {
          if (!saveInProgress) return;
          editorStatus.textContent = 'Still waiting for Studio. Check its tab before trying again; saving may still be underway.';
        }, 120000);
        return;
      }
      saveInProgress = false;
      saveFeedbackShown = true;
      saveCompleted = !!message.ok;
      if (saveCompleted) lastSavedPosition = pendingSavePosition;
      pendingSavePosition = null;
      saveButton.disabled = saveCompleted;
      editorStatus.textContent = message.ok
        ? 'Saved to this color. You can close this page.'
        : (message.error || 'Could not save placement.');
    });
  }
})();
class Monogram {
    constructor() {
        this.mainBtn = document.querySelector('.product__submit__add.product-add-cart');
        this.btn = document.querySelector('.button-trigger-monogram');
        this.container = document.querySelector('.product-monogram');
        this.mainbody = document.querySelector('.mainbody');
        this.product_container = this.container.parentNode.querySelector('.product__form__wrapper');
        this.btn_close = this.container.querySelector('.btn-close');
        this.textInput = this.container.querySelector('input.input-letter');
        this.qtyInput = this.container.querySelector('input.count-input');
        this.btnPlus = this.container.querySelector('button.button-plus');
        this.btnMinus = this.container.querySelector('button.button-minus');
        this.btnCart = this.container.querySelector('button.addTo-button');
        this.total_block = this.container.querySelector('.box-total');
        this.prod_price = this.container.querySelector('.prod-price').getAttribute('data-price') * 1;
        this.mono_price = this.container.querySelector('.monogram-price').getAttribute('data-price') * 1;
        this.main_product = this.container.querySelector('input[name="main_prod"]').value;
        this.mono_product = this.container.querySelector('input[name="mono_prod"]').value;
        this.attrs = {};
        this.qty = this.qtyInput.value * 1;
        this.price_decimals = 2;
        this.old_total = Number(((this.prod_price + this.mono_price) * this.qty) / 100).toFixed(this.price_decimals);
        this.old_price = Number(this.prod_price / 100).toFixed(this.price_decimals);
        this.items = ['monogram-font-face', 'monogram-font-size', 'monogram-color'];
        if (this.btn) {
            if (!this.container) {
                this.btn.style.display = 'none';
            }
        }
        this.setActions();
    }

    setActions() {
       this.btn.addEventListener('click', this.toggleContainer.bind(this));
        this.btn_close.addEventListener('click', this.hideContainer.bind(this));
        if (this.textInput) {
            this.textInput.addEventListener('keyup', this.inputChange.bind(this));
            this.textInput.addEventListener('input', this.inputChange.bind(this));
        }
        this.qtyInput.addEventListener('keyup', this.updatePrice.bind(this));
        this.qtyInput.addEventListener('change', this.updatePrice.bind(this));

        this.btnPlus.addEventListener('click', function (e) { e.preventDefault(); this.updateQty() }.bind(this));
        this.btnMinus.addEventListener('click', function (e) { e.preventDefault(); this.updateQty('minus') }.bind(this));

        this.btnCart.addEventListener('click', (e) => { e.preventDefault(); this.addToCart(); });
            if (this.mainBtn) {
                this.mainBtn.addEventListener('click', (e) => {
                    this.setMainAttrs();

                    if (this.container.classList.contains('monogram-show') || this.attrs.letters !== '') {
                        e.preventDefault();
                        e.stopImmediatePropagation();

                        this.addToCart();
                    }
                });
            }
        this.updateFields();
        this.setMainAttrs();
        document.querySelectorAll('.swatch__input[data-single-option-selector]').forEach((input) => {
    input.addEventListener('change', () => {
        if (this.container.classList.contains('monogram-show')) {
            this.hideContainer();
        }
    });
});
    }

    updateFields(){
        this.items.forEach(function (item) {
            let type = item.replace('monogram-', '').replace('-', '_');
            let check_block = '';
            if (type === 'color') {
                monogram_colors.forEach(function (mcolor) {
                    if (typeof prod_person[this.main_product].applicable_text_colours !== 'undefined') {
                        prod_person[this.main_product].applicable_text_colours.forEach(function (color) {
                            let scolor = '';
                            if (mcolor.title.toLowerCase() === color.toLowerCase()) {
                                scolor = mcolor.colour;
                                check_block += this.inputHtml(type, {'title': color, 'color': scolor});
                            }
                        }.bind(this));
                    }
                }.bind(this));
            }
            if (type === 'font_face') {
                monogram_font_faces.forEach(function (mface) {
                    check_block += this.inputHtml(type, { 'title': mface.title, 'image': mface.image });
                }.bind(this));
            }
            if (type === 'font_size') {
                monogram_font_sizes.forEach(function (msize) {
                    check_block += this.inputHtml(type, { 'title': msize.title, 'image': msize.image });
                }.bind(this));
            }
            this.container.querySelector('.' + item + ' .item-switches').innerHTML = check_block;
        }.bind(this));

        this.container.querySelectorAll('.item-switches button').forEach(function (btn) {
            let block = btn.closest('.item-monogram');
            btn.addEventListener('click', (e) => { this.swatchChange(e, block) });
        }.bind(this));

        this.items.forEach(function (item) {
            this.container.querySelector('.' + item + ' .item-switches button').click();
        }.bind(this));
    }

    inputHtml(type = 'color', settings = {}) {
        let str = '';
        switch (type) {
            case "color": {
                str = "<div class=\"switch " + settings.title.toLowerCase() + "\">\n" +
                    "<button type=\"button\" name=\"color\" title=\"" + settings.title + "\" class=\"relative\"\n";
                if (settings.color !== '') {
                    str += " style=\"background-color: " + settings.color + ";\"";
                    str += " value='" + settings.title.toLowerCase() + "'";
                } else {
                    str += " value='blind'";
                }
                str += "></button></div>";
                break;
            }
            case "font_size": {
                str = "<div class=\"switch\">\n" +
                    "<button type=\"button\" name=\"font_size\" title=\"" + settings.title + "\" class=\"button-inf button-size\"\n" +
                    " value='" + settings.title.toLowerCase() + "'\n" +
                    " style=\"background-image: url('" + settings.image + "');\"></button>\n" +
                    "</div>";
                break;
            }
            case "font_face": {
                str = "<div class=\"switch\">\n" +
                    "<button type=\"button\" name=\"font\" title=\"" + settings.title + "\" class=\"button-inf button-fonts\"\n" +
                    " value='" + settings.title.toLowerCase() + "'\n" +
                    " style=\"background-image: url('" + settings.image + "');\"></button>\n" +
                    "</div>";
                break;
            }
        }
        return str;
    }
    toggleContainer(e) {
    e.preventDefault();

    if (this.container.classList.contains('monogram-show')) {
        this.hideContainer(e);
    } else {
        this.showContainer(e);
    }
}
    showContainer(e) {
        e.preventDefault();
        if (document.querySelector('.product-media__slider-swiper')) {
            let index = (parseInt(prod_person[this.main_product].front_facing_image) >= 1) ? parseInt(prod_person[this.main_product].front_facing_image) : 2;
            let slider2 = document.querySelector('.product-media__slider-swiper');
            slider2.swiper.slideTo(index - 1);
        }
        this.container.closest('.form__wrapper').querySelectorAll('.product__block').forEach(function (block) {
           // block.style.display = "none";
        });
        if (this.container.closest('.form__wrapper').querySelector('.product__selectors')) {
            //this.container.closest('.form__wrapper').querySelector('.product__selectors').style.display = "none";
        }
        //this.container.style.display = "flex";
        this.mainbody.classList.add("monogram-show-main");
        this.container.classList.add("monogram-show");
         // Focus the input field
    const input = this.container.querySelector('.input-letter');
    if (input) {
        input.focus();
    }
        this.updateImage();
        this.updateButtonPrice();
    }

    hideContainer(e) {
         if (e) e.preventDefault();
       // this.container.style.display = "none";
        this.mainbody.classList.remove("monogram-show-main");
         this.container.classList.remove("monogram-show");
        this.container.closest('.form__wrapper').querySelectorAll('.product__block').forEach(function (block) {
           // block.style.display = "block";
        });
        this.container.closest('.form__wrapper').querySelector('.product__selectors').style.display = "block";
        const preview = document.querySelector('.monogram-preview');
if (preview) {
    preview.remove();
}
const buttonPrice = document.querySelector('.btnpp .product__price--regular');

if (buttonPrice) {
    buttonPrice.innerHTML = this.container.querySelector('.prod-price').innerHTML;
}
    }

    inputChange(e) {
      let value = event.currentTarget.value;
      let fixedValue = "";
      for (const c of value) {
        let code = c.charCodeAt(0);
        if (( code >= 0x20 && code <0x7F)) {
          fixedValue = fixedValue + c;
        }
      }

      // Apply changes if chars were removed
      if (value!=fixedValue) {
        event.currentTarget.value = fixedValue;
      }
      event.currentTarget.value = this.clearInputVal(event.currentTarget.value);
        this.updateImage();
    }

    clearInputVal(val) {
        let max_length = parseInt(this.textInput.getAttribute('maxLength'));
        if (!max_length) max_length = 3;
        return val.toUpperCase().replace(/[^A-Z0-9,.]/g, '').substring(0, max_length);
    }

    updateImage() {
        let main_image = document.querySelector('.product-single__gallery .product-single__media-slide.swiper-slide-active');
        if (main_image) {
            let url = main_image.querySelector('a').getAttribute('href').split(/(products|files)/);
            // let url = main_image.querySelector('a').getAttribute('href').split('products');
            url = url[0];
            let absolute_div = document.createElement('div');
            absolute_div.classList.add('absolute');
            absolute_div.classList.add('monogram-preview');
            absolute_div.style.position = 'absolute';
            absolute_div.style.marginTop = '0'; absolute_div.style.top = (Number(prod_person[this.main_product].vertical_letter_position || 0) + 3) + '%';
            absolute_div.style.marginLeft = '0'; absolute_div.style.left = (Number(prod_person[this.main_product].horizontal_letter_position || 0) + 4) + '%';
            absolute_div.style.width = prod_person[this.main_product].width_container_desktop+'%';
            absolute_div.style.height = prod_person[this.main_product].height_container_desktop+'%';
            absolute_div.style.transform = 'scale('+prod_person[this.main_product].letter_scale/100+')';
            if (window.innerWidth < 768 && prod_person[this.main_product].mobile_letter_scale) {
                absolute_div.style.transform = 'scale(' + prod_person[this.main_product].mobile_letter_scale / 100 + ')';
            }
            this.setMainAttrs();
            let file_name = url + '/files/' + this.attrs.font.toLowerCase() + '_' + this.attrs.size.toLowerCase() + '_' + this.attrs.color.toLowerCase();
            this.attrs.letters.split('').forEach(function (letter) {
                let l_d = document.createElement('img');
                let date = new Date();
                if (letter === '.') letter = 'dot';
                if (letter === ',') letter = 'comma';
                l_d.setAttribute('src', file_name + '_' + letter.toLowerCase() + '.png?v=' + `${date.getFullYear()}-${date.getMonth()}-${date.getDay()}-${date.getHours()}-${date.getMinutes()}`)
                l_d.classList.add('monogram-letter');
                absolute_div.appendChild(l_d);
            });
            if (main_image.querySelector('.monogram-preview')) {
                main_image.querySelector('.monogram-preview').remove();
            }
            main_image.appendChild(absolute_div);
        }
    }

    setMainAttrs() {
        let main_color_block = this.container.querySelector('.monogram-color .switch.active button');
        if (!main_color_block) {
            this.container.querySelector('.monogram-color .switch').classList.add('active');
            main_color_block = this.container.querySelector('.monogram-color .switch.active button');
        }
        this.attrs.color = main_color_block.getAttribute('value');
        let main_font_size_block = this.container.querySelector('.monogram-font-size .switch.active button');
        if (!main_font_size_block) {
            this.container.querySelector('.monogram-font-size .switch').classList.add('active');
            main_font_size_block = this.container.querySelector('.monogram-font-size .switch.active button');
        }
        this.attrs.size = main_font_size_block.getAttribute('value');
        let main_font_face_block = this.container.querySelector('.monogram-font-face .switch.active button');
        if (!main_font_face_block) {
            this.container.querySelector('.monogram-font-face .switch').classList.add('active');
            main_font_face_block = this.container.querySelector('.monogram-font-face .switch.active button');
        }
        this.attrs.font = main_font_face_block.getAttribute('value');
        this.attrs.letters = this.textInput.value;
        if (this.attrs.letters === '') {
            this.btnCart.disabled = true;
        } else {
            this.btnCart.disabled = false;
        }
        this.updatePrice();
        this.container.querySelectorAll('.errors').forEach(function (err_b) {
            err_b.remove();
        })
    }

    swatchChange(e, block) {
        e.preventDefault();
        let a_switches = block.querySelectorAll('.item-switches .switch.active');
        if (a_switches) {
            a_switches.forEach(function (sw) {
                sw.classList.remove('active');
            });
        }
        e.target.closest('.switch').classList.add('active');
       if (block.querySelector('.attr_name')) {
    block.querySelector('.attr_name').textContent = e.target.getAttribute('title');

    const colorBox = block.querySelector('.clrbxx');
    if (colorBox) {
        colorBox.style.backgroundColor = e.target.style.backgroundColor;
    }
}
        this.updateImage();
    }

    updateQty(type = "plus") {
        if (type === 'plus') {
            this.qtyInput.value = parseInt(this.qtyInput.value) + 1;
        } else {
            if (type === 'minus') {
                this.qtyInput.value = parseInt(this.qtyInput.value) - 1;
            }
        }
        this.updatePrice();
    }
updateButtonPrice() {
    const buttonPrice = document.querySelector('.btnpp .product__price--regular');

    if (
        buttonPrice &&
        this.container.classList.contains('monogram-show')
    ) {
        buttonPrice.innerHTML = this.total_block.innerHTML;
    }
}
    updatePrice() {
      this.prod_price = this.container.querySelector('.prod-price').getAttribute('data-price') * 1;
      this.mono_price = this.container.querySelector('.monogram-price').getAttribute('data-price') * 1;
        let ch_val = this.qtyInput.value.replace(/[^0-9]/g, '');
        if (this.qtyInput.value * 1 !== ch_val * 1) {
            this.qtyInput.value = ch_val * 1;
        }
        let old_total = Number(((this.prod_price + this.mono_price) * this.qty) / 100);
        let new_total = Number(((this.prod_price + this.mono_price) * ch_val) / 100);
        this.total_block.innerHTML = this.total_block.innerHTML.replace(this.old_total, new_total.toFixed(this.price_decimals));
        this.container.querySelector('.product-monogram-info .info-right .prod-price').innerHTML =
            this.container.querySelector('.product-monogram-info .info-right .prod-price').innerHTML.replace(
                this.old_price,
                Number(this.prod_price / 100).toFixed(this.price_decimals)
            );
        this.old_total = old_total.toFixed(this.price_decimals);
        this.old_price = Number(this.prod_price / 100).toFixed(this.price_decimals);
        this.qty = ch_val * 1;

       if (this.container.classList.contains('monogram-show')) {
    this.updateButtonPrice();
}

    }

    addToCart() {
        if (this.btnCart.disabled) return;
        window.cart.button = this.btnCart;
        this.container.querySelectorAll('.errors').forEach(function (err_b) {
            err_b.remove();
        });
        this.setMainAttrs();
        let errorContainer = this.container.querySelector('[data-cart-errors-container]');
        let monogram_properties = {
            'Personalisation': 'Monogram',
            'Letters': this.attrs.letters,
            'Colour': this.attrs.color,
            'Font': this.attrs.font,
            'Size': this.attrs.size
        }
        if (this.product_container) {
            let preorder_input = this.product_container.querySelector('input[name="properties[preorder_date]"]');
            if (preorder_input && typeof preorder_input.value !== 'undefined' && preorder_input.value !== '') {
                monogram_properties['preorder_date'] = preorder_input.value;
            }
        }
        let formData = {
            'items': [
                {
                    'id': this.mono_product,
                    'quantity': this.qty
                },
                {
                    'id': this.main_product,
                    'quantity': this.qty,
                    'properties': monogram_properties
                }
            ]
        };
        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
            .then(response => {
                return response.json();
            }).then(response => {
                if (response.status) {
                    errorContainer.innerHTML = `
                  <div class="errors" data-error>
                    ${response.message}: ${response.description}
                  </div>
                `;
                    return;
                }

                if (window.cart.cartDrawerEnabled) {
                    window.cart.getCart();
                } else {
                    window.location = theme.routes.cart_url;
                }
            });
    }
}
window.product_monogram = new Monogram();

const monogramColor = document.querySelector('.item-monogram.monogram-color');
const trigger = document.querySelector('.outcnlrr');

trigger.addEventListener('click', function (e) {
    e.stopPropagation();
    monogramColor.classList.add('active');
});

document.addEventListener('click', function (e) {
    if (!monogramColor.contains(e.target)) {
        monogramColor.classList.remove('active');
    }
});
document.addEventListener('click', function (e) {
    if (e.target.closest('.item-monogram.monogram-color .switch')) {
        document
            .querySelector('.item-monogram.monogram-color')
            ?.classList.remove('active');
    }
});